<template>
  <v-content>
    <Header></Header>
    <!-- <v-layout
      style="background-color: #F8F8F8;margin-bottom: 8rem"
      justify-center
      :style="{
        background: `url(${require('../assets/portfolio-bg.png')})`,
        'background-size': 'cover',
      }"
    > -->
    <v-layout
      class="justify-center mt-2"
      style="background-color: #F8F7F7;margin-bottom: 8rem"
    >
      <v-flex xs11 sm10 lg9>
        <v-card
          flat
          class="my-12 pa-3 pa-md-7"
          style="border: solid 1px #C4C4C4; border-radius: 10px;"
        >
          <v-layout justify-center>
            <v-flex xs12>
              <v-layout justify-space-around class="d-flex align-center">
                <v-flex shrink>
                  <div
                    class="txt-large mb-2"
                    :class="{ 'txt-m-large': $vuetify.breakpoint.smAndDown }"
                  >
                    {{ $t("create-portfolio") }}
                  </div>
                </v-flex>

                <v-spacer />

                <v-flex shrink class="d-flex align-center">
                  <div class="mr-3 txt-large">Status : Public</div>
                  <v-switch
                    color="#FD5245"
                    class="mt-0"
                    hide-details
                    v-model="portfolioDetail.is_approve"
                  ></v-switch>
                </v-flex>
              </v-layout>

              <v-divider class="my-7"></v-divider>
              <v-layout :column="$vuetify.breakpoint.smAndDown">
                <v-flex xs3 mb-5 mb-md-0>
                  <v-layout>
                    <v-flex shrink txt-head>
                      <div class="txt-head mb-2">
                        {{ $t("portfolio-detail") }}
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6>
                  <div>
                    <span class="font-weight-bold">{{ $t("category") }}</span>
                    <v-select
                      :items="categoryList"
                      :item-text="$i18n.locale === 'th' ? 'name_th' : 'name_en'"
                      item-value="id"
                      dense
                      solo
                      flat
                      class="mt-2 radius8"
                      menu-props="offset-y"
                      @input="changeCategory"
                      v-model="category_id"
                    ></v-select>
                  </div>

                  <div v-if="subcategoryList.length > 0 && category_id">
                    <span class="font-weight-bold">{{
                      $t("subcategory")
                    }}</span>
                    <v-select
                      :items="subcategoryList"
                      :item-text="$i18n.locale === 'th' ? 'name_th' : 'name_en'"
                      item-value="id"
                      dense
                      solo
                      flat
                      class="mt-2 radius8"
                      menu-props="offset-y"
                      v-model="portfolioDetail.subcategory_id"
                    ></v-select>
                  </div>
                </v-flex>
                <v-flex xs3> </v-flex>
              </v-layout>
              <v-divider class="my-7"></v-divider>
              <v-layout :column="$vuetify.breakpoint.smAndDown">
                <v-flex xs3> </v-flex>
                <v-flex xs6>
                  <span class="font-weight-bold">{{
                    $t("project-title")
                  }}</span>
                  <v-text-field
                    dense
                    solo
                    flat
                    class="mt-2 radius8"
                    v-model="portfolioDetail.project_title"
                  ></v-text-field>

                  <span class="font-weight-bold">{{
                    $t("project-brief")
                  }}</span>
                  <v-text-field
                    dense
                    solo
                    flat
                    class="mt-2 radius8"
                    v-model="portfolioDetail.project_brief"
                  ></v-text-field>

                  <v-layout justify-space-between>
                    <div class="font-weight-bold d-flex align-center">Tag</div>
                    <v-btn text color="#FD5246" @click="setTagType(0)">{{
                      $t("add-new-tag")
                    }}</v-btn>
                  </v-layout>

                  <v-autocomplete
                    :items="allTags"
                    item-text="name"
                    item-value="id"
                    chips
                    multiple
                    deletable-chips
                    dense
                    solo
                    flat
                    class="mt-2 radius8"
                    v-model="portfolioTag"
                  ></v-autocomplete>

                  <v-layout justify-space-between>
                    <div class="font-weight-bold d-flex align-center">
                      Award Tag
                    </div>
                    <v-btn text color="#FD5246" @click="setTagType(1)">{{
                      $t("add-new-tag")
                    }}</v-btn>
                  </v-layout>
                  <v-autocomplete
                    :items="allAwardTags"
                    item-text="name"
                    item-value="id"
                    chips
                    multiple
                    deletable-chips
                    dense
                    solo
                    flat
                    class="mt-2 radius8"
                    v-model="portfolioTagAward"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
              <v-layout justify-center>
                <v-flex xs10>
                  <span class="font-weight-bold">{{ $t("content") }}</span>
                  <v-layout>
                    <v-flex>
                      <!--                                            <wysiwyg v-model="portfolioDetail.detail" />-->
                      <editor
                        api-key="lo7s75k6xgvk40erne259q3hzune1o7gpme4m1txjmfvzr3i"
                        :init="editorSetting.init"
                        v-model="portfolioDetail.detail"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout justify-center>
                <v-flex xs12>
                  <!-- add custom tag & tag award -->
                  <v-dialog v-model="tagModal" width="300">
                    <v-card class="pa-7" style="position: relative;">
                      <v-btn
                        depressed
                        small
                        fab
                        color="transparent"
                        absolute
                        style="top: 0; right: 0"
                        @click="tagModal = !tagModal"
                      >
                        <v-icon>close</v-icon>
                      </v-btn>
                      <span class="font-weight-bold">{{
                        tagType === 0 ? $t("add-tag") : $t("add-tag-award")
                      }}</span>
                      <v-text-field
                        dense
                        solo
                        flat
                        class="mt-2 radius8"
                        v-model="newTag"
                      ></v-text-field>
                      <div class="text-end">
                        <v-btn
                          depressed
                          block
                          dark
                          color="#FD5246"
                          :loading="btnTagLoading"
                          @click="addTag"
                          >{{ $t("add") }}</v-btn
                        >
                      </div>
                    </v-card>
                  </v-dialog>
                </v-flex>
                <v-flex xs3> </v-flex>
              </v-layout>

              <v-divider class="my-7"></v-divider>
              <v-layout :column="$vuetify.breakpoint.smAndDown">
                <v-flex xs3 mb-5 mb-md-0>
                  <v-layout>
                    <v-flex shrink txt-head>
                      <div class="txt-head mb-2">{{ $t("upload-image") }}</div>
                      <!--                                            <div class="txt-detail">อัพโหลดภาพผลงาน</div>-->
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6>
                  <v-layout
                    justify-space-between
                    mb-5
                    :column="$vuetify.breakpoint.smAndDown"
                  >
                    <span class="font-weight-bold mb-5 mb-md-0 pt-md-2">{{
                      $t("cover-img")
                    }}</span>
                    <!-- cover image mobile size -->
                    <div
                      class="radius8 mb-4"
                      v-if="$vuetify.breakpoint.smAndDown"
                      :style="{
                        'padding-top': portfolioDetail.cover_img_path
                          ? '0'
                          : '100%',
                        height: portfolioDetail.cover_img_path ? 'auto' : '0',
                      }"
                      style="width: 100%; border: solid 1px #C4C4C4; position: relative"
                    >
                      <v-img
                        width="100%"
                        height="100%"
                        v-if="coverReload"
                        class="radius8"
                        style="object-fit: cover;"
                        :src="
                          portfolioDetail.cover_img_path
                            ? http +
                              httpImgPath +
                              'images_cover/' +
                              portfolioDetail.cover_img_path
                            : ''
                        "
                      ></v-img>
                      <loading
                        color="#FD5246"
                        :active.sync="isLoadingImageCover"
                        :can-cancel="false"
                        :is-full-page="false"
                      ></loading>
                      <v-btn
                        fab
                        absolute
                        depressed
                        dark
                        x-small
                        style="right: -13px; top: -13px"
                        color="#FD5246"
                        v-if="portfolioDetail.cover_img_path"
                        @click="clearCoverImage(null)"
                      >
                        <v-icon>close</v-icon>
                      </v-btn>
                    </div>
                    <!-- end mobile size here -->
                    <v-btn
                      outlined
                      color="#FD5246"
                      @click="$refs.portfolio_cover.click()"
                      >{{ $t("choose-file") }}</v-btn
                    >
                    <input
                      id="portfolio_cover"
                      ref="portfolio_cover"
                      class="d-none"
                      type="file"
                      accept="image/*"
                      @input="onCoverChanged"
                    />
                  </v-layout>
                  <!-- cover image desktop size here -->
                  <div
                    class="radius8"
                    v-if="$vuetify.breakpoint.mdAndUp"
                    style="width: 150px; height: 150px; border: solid 1px #C4C4C4; position: relative;"
                  >
                    <v-img
                      width="100%"
                      height="100%"
                      v-if="coverReload"
                      class="radius8"
                      style="object-fit: cover;"
                      :src="
                        portfolioDetail.cover_img_path
                          ? http +
                            httpImgPath +
                            'images_cover/' +
                            portfolioDetail.cover_img_path
                          : ''
                      "
                    ></v-img>
                    <loading
                      color="#FD5246"
                      :active.sync="isLoadingImageCover"
                      :can-cancel="false"
                      :is-full-page="false"
                    ></loading>
                    <v-btn
                      fab
                      absolute
                      depressed
                      dark
                      x-small
                      style="right: -13px; top: -13px"
                      color="#FD5246"
                      v-if="portfolioDetail.cover_img_path"
                      @click="clearCoverImage(null)"
                    >
                      <v-icon>close</v-icon>
                    </v-btn>
                  </div>
                  <div class="mt-2" style="font-size: 12px;color: #FD5246">
                    <div>* {{ $t("note") }}: {{ $t("recommend-size") }}</div>
                    <div>
                      <div>- {{ $t("use-image-content-size") }}</div>
                      <div>- {{ $t("use-image-content-file-size") }}</div>
                    </div>
                  </div>
                  <!-- end desktop size here -->
                </v-flex>
                <v-flex xs3> </v-flex>
              </v-layout>

              <!-- Upload image cover Share -->
              <v-divider class="my-7"></v-divider>
              <v-layout :column="$vuetify.breakpoint.smAndDown">
                <v-flex xs3 mb-5 mb-md-0></v-flex>
                <v-flex xs6>
                  <v-layout
                    justify-space-between
                    mb-5
                    :column="$vuetify.breakpoint.smAndDown"
                  >
                    <span class="font-weight-bold mb-5 mb-md-0 pt-md-2">{{
                      $t("cover-img-share")
                    }}</span>

                    <!-- cover image mobile size -->
                    <div
                      class="radius8 mb-4"
                      v-if="$vuetify.breakpoint.smAndDown"
                      :style="{
                        'padding-top': portfolioDetail.cover_img_share_path
                          ? '0'
                          : '100%',
                        height: portfolioDetail.cover_img_share_path
                          ? 'auto'
                          : '0',
                      }"
                      style="width: 100%; border: solid 1px #C4C4C4; position: relative"
                    >
                      <v-img
                        width="100%"
                        height="100%"
                        v-if="coverShareReload"
                        class="radius8"
                        style="object-fit: cover;"
                        :src="
                          portfolioDetail.cover_img_share_path
                            ? http +
                              httpImgPath +
                              'images_cover_share/' +
                              portfolioDetail.cover_img_share_path
                            : ''
                        "
                      ></v-img>
                      <loading
                        color="#FD5246"
                        :active.sync="isLoadingImageShare"
                        :can-cancel="false"
                        :is-full-page="false"
                      ></loading>
                      <v-btn
                        fab
                        absolute
                        depressed
                        dark
                        x-small
                        style="right: -13px; top: -13px"
                        color="#FD5246"
                        v-if="portfolioDetail.cover_img_share_path"
                        @click="clearCoverImageShare(null)"
                      >
                        <v-icon>close</v-icon>
                      </v-btn>
                    </div>
                    <!-- end mobile size here -->
                    <v-btn
                      outlined
                      color="#FD5246"
                      @click="$refs.portfolio_cover_share.click()"
                      >{{ $t("choose-file") }}</v-btn
                    >
                    <input
                      id="portfolio_cover_share"
                      ref="portfolio_cover_share"
                      type="file"
                      class="d-none"
                      accept="image/*"
                      @change="onCoverShareChanged"
                    />
                  </v-layout>

                  <!-- cover image desktop size here -->
                  <div
                    class="radius8"
                    v-if="$vuetify.breakpoint.mdAndUp"
                    style="width: 300px; height: 150px; border: solid 1px #C4C4C4; position: relative;"
                  >
                    <v-img
                      width="100%"
                      height="100%"
                      v-if="coverShareReload"
                      class="radius8"
                      style="object-fit: cover;"
                      :src="
                        portfolioDetail.cover_img_share_path
                          ? http +
                            httpImgPath +
                            'images_cover_share/' +
                            portfolioDetail.cover_img_share_path
                          : ''
                      "
                    ></v-img>
                    <loading
                      color="#FD5246"
                      :active.sync="isLoadingImageShare"
                      :can-cancel="false"
                      :is-full-page="false"
                    ></loading>
                    <v-btn
                      fab
                      absolute
                      depressed
                      dark
                      x-small
                      style="right: -13px; top: -13px"
                      color="#FD5246"
                      v-if="portfolioDetail.cover_img_share_path"
                      @click="clearCoverImageShare(null)"
                    >
                      <v-icon>close</v-icon>
                    </v-btn>
                  </div>
                  <div class="mt-2" style="font-size: 12px;color: #FD5246">
                    <div>* {{ $t("note") }}: {{ $t("recommend-size") }}</div>
                    <div>
                      <div>- {{ $t("use-image-content-share") }}</div>
                      <div>- {{ $t("use-image-content-share-file-size") }}</div>
                    </div>
                  </div>
                  <!-- end desktop size here -->
                </v-flex>
                <v-flex xs3> </v-flex>
              </v-layout>

              <v-divider class="my-7"></v-divider>
              <v-layout :column="$vuetify.breakpoint.smAndDown">
                <v-flex xs3> </v-flex>
                <v-flex xs6>
                  <v-layout
                    justify-space-between
                    mb-5
                    :column="$vuetify.breakpoint.smAndDown"
                  >
                    <v-flex>
                      <v-layout
                        justify-space-between
                        :column="$vuetify.breakpoint.smAndDown"
                      >
                        <span class="font-weight-bold mb-3 mb-md-0 pt-md-2">
                          {{ $t("port-img") }}
                        </span>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <v-layout
                    mb-5
                    :column="$vuetify.breakpoint.smAndDown"
                    v-for="(item, i) in portfolioDetail.portfolio_image"
                    :key="i"
                    wrap
                  >
                    <v-flex
                      xs3
                      mb-3
                      mb-md-0
                      style="display: flex; width: 100%; position: relative"
                      :style="{
                        height: $vuetify.breakpoint.smAndDown
                          ? '150px'
                          : 'auto',
                      }"
                    >
                      <div
                        class="radius8"
                        style="border: solid 1px #C4C4C4; display: flex; position: relative;"
                        :style="{
                          width: $vuetify.breakpoint.smAndDown
                            ? '100%'
                            : '95px',
                          height: $vuetify.breakpoint.smAndDown
                            ? 'auto'
                            : '95px',
                          'padding-top':
                            $vuetify.breakpoint.mdAndUp || item.img_path
                              ? '0'
                              : '100%',
                        }"
                      >
                        <v-btn
                          fab
                          depressed
                          absolute
                          v-if="!item.img_path"
                          color="#72C3B6"
                          small
                          dark
                          @click="dialog = true"
                          style="top: calc(50% - 20px); left: calc(50% - 20px)"
                        >
                          <v-icon large>add</v-icon>
                        </v-btn>

                        <v-img
                          width="100%"
                          height="100%"
                          class="radius8"
                          style="object-fit: cover;"
                          v-if="imgReload"
                          :src="
                            item.img_path
                              ? http + httpImgPath + 'images/' + item.img_path
                              : ''
                          "
                        ></v-img>
                        <v-btn
                          fab
                          absolute
                          depressed
                          dark
                          x-small
                          style="right: -13px; top: -13px"
                          color="#FD5246"
                          @click="removeAnImage(i)"
                        >
                          <v-icon>close</v-icon>
                        </v-btn>
                      </div>
                      <input
                        :ref="`imageport_${i}`"
                        :id="`imageport_${i}`"
                        type="file"
                        class="d-none"
                        accept="image/*"
                        value=""
                        @change="onMoreImgChanged($event, i)"
                      />
                    </v-flex>

                    <v-flex mb-5 mb-md-0 class="d-flex align-center">
                      <div style="width: 100%" class="pl-md-3">
                        <div class="mb-2 txt-detail">
                          {{ $t("img-desc") }}
                        </div>
                        <v-text-field
                          solo
                          flat
                          v-model="item.detail"
                          hide-details
                          class="radius8"
                        ></v-text-field>
                      </div>
                    </v-flex>
                    <!-- ************************************** Modal Upload image on Album ********************************************* -->
                    <v-flex class="d-flex justify-center align-center">
                      <div>
                        <v-dialog
                          v-model="dialog"
                          overlay-opacity="0.75"
                          overlay-color="#fff"
                          width="1200"
                        >
                          <div
                            max-height="900"
                            height="800"
                            class="pa-2"
                            style="border: 2px solid #8c8c8c;background-color:#fff;"
                          >
                            <div class="text-end">
                              <v-icon
                                style="cursor: pointer"
                                @click="dialog = false"
                              >
                                clear
                              </v-icon>
                            </div>
                            <v-card-actions class="pa-0 ma-0">
                              <v-layout class="px-sm-6 px-2 py-10" wrap>
                                <v-spacer
                                  v-show="$vuetify.breakpoint.smAndUp"
                                ></v-spacer>
                                <v-flex
                                  class="lg4 md4 sm5 xs12 mx-2 mb-4 d-flex justify-center align-center"
                                >
                                  <v-btn
                                    depressed
                                    large
                                    block
                                    dark
                                    :color="
                                      btnUploadActive ? '#fd5246' : '#C5C5C5'
                                    "
                                    @click="onHandleBtnUploadImage('upload')"
                                  >
                                    อัพโหลด
                                  </v-btn>
                                </v-flex>
                                <v-flex
                                  class="lg4 md4 sm5 xs12 mx-2 mb-4 mx-2 d-flex justify-center align-center"
                                >
                                  <v-btn
                                    depressed
                                    width="100%"
                                    large
                                    block
                                    :color="btnFbActive ? '#1877F2' : '#C5C5C5'"
                                    style="position: relative"
                                    dark
                                    @click="onHandleBtnUploadImage('facebook')"
                                  >
                                    <v-layout class="justify-center">
                                      <v-spacer></v-spacer>
                                      <v-flex
                                        shrink
                                        mx-3
                                        class="d-flex justify-center align-center"
                                      >
                                        <img
                                          width="25px"
                                          :src="
                                            require('../assets/facebook icon.png')
                                          "
                                        />
                                      </v-flex>
                                      <v-flex
                                        shrink
                                        class="d-flex justify-center align-center"
                                      >
                                        อัพโหลด ด้วย Facebook
                                      </v-flex>
                                      <v-spacer></v-spacer>
                                    </v-layout>
                                  </v-btn>
                                </v-flex>
                                <v-spacer
                                  v-show="$vuetify.breakpoint.smAndUp"
                                ></v-spacer>
                              </v-layout>
                            </v-card-actions>

                            <v-card-text>
                              <!-- Upload Default -->
                              <div v-if="btnUploadActive" class="modal-upload">
                                <div
                                  v-if="show"
                                  :style="
                                    $vuetify.breakpoint.smAndUp
                                      ? { height: '100%', padding: '0 4rem' }
                                      : { height: '100%', padding: '0 1rem' }
                                  "
                                  class="d-flex flex-column justify-center align-center"
                                >
                                  <div class="font-weight-bold mb-6">
                                    {{ $t("uploading") }}
                                  </div>
                                  <v-progress-linear
                                    v-model="progress"
                                    color="#FD5246"
                                    dark
                                    height="25"
                                    reactive
                                    :active="show"
                                  >
                                    <strong>{{ progress }} %</strong>
                                  </v-progress-linear>
                                </div>
                                <div v-else>
                                  <v-btn
                                    fab
                                    depressed
                                    absolute
                                    color="#72C3B6"
                                    large
                                    dark
                                    style="top: calc(50% - 35px); left: calc(50% - 35px)"
                                    @click="clickImageInput(i)"
                                  >
                                    <v-icon large>add</v-icon>
                                  </v-btn>
                                </div>
                              </div>

                              <!-- Upload Facebook -->
                              <div v-else>
                                <v-card
                                  flat
                                  style="background-color: #f8f8f8;"
                                  class="pa-6"
                                >
                                  <loading
                                    color="#FD5246"
                                    :active.sync="isLoadingFb"
                                    :can-cancel="false"
                                    :is-full-page="false"
                                  ></loading>

                                  <!-- on loading uploading photo facebook -->
                                  <div
                                    v-if="showFb"
                                    :style="
                                      $vuetify.breakpoint.smAndUp
                                        ? {
                                            padding: '0 4rem',
                                          }
                                        : {
                                            padding: '0 1rem',
                                          }
                                    "
                                    class="modal-upload d-flex flex-column justify-center align-center"
                                  >
                                    <div class="font-weight-bold mb-6">
                                      {{ $t("uploading") }}
                                    </div>
                                    <v-progress-linear
                                      v-model="progressFb"
                                      color="#1877F2"
                                      dark
                                      height="25"
                                      reactive
                                      :active="showFb"
                                    >
                                      <strong>{{ progressFb }} %</strong>
                                    </v-progress-linear>
                                  </div>

                                  <!-- select photo facebook -->
                                  <div v-else>
                                    <!-- btn select -->
                                    <v-layout class="d-flex justify-center">
                                      <v-spacer></v-spacer>
                                      <v-flex
                                        class="mx-3 xs2 upload-fb-btn text-center"
                                        :class="
                                          isActive ? 'active-select-btn-fb' : ''
                                        "
                                      >
                                        <v-btn
                                          @click="isActive = true"
                                          color="#FD5246"
                                          dark
                                          block
                                          text
                                        >
                                          <span class="title-upload-fb">
                                            รูปภาพล่าสุด
                                          </span>
                                        </v-btn>
                                      </v-flex>
                                      <v-flex
                                        class="mx-3 xs2 upload-fb-btn text-center"
                                        :class="
                                          !isActive
                                            ? 'active-select-btn-fb'
                                            : ''
                                        "
                                      >
                                        <v-btn
                                          @click="isActive = false"
                                          color="#FD5246"
                                          dark
                                          block
                                          text
                                        >
                                          <span class="title-upload-fb">
                                            อัลบั้ม
                                          </span>
                                        </v-btn>
                                      </v-flex>
                                      <v-spacer></v-spacer>
                                    </v-layout>

                                    <!-- list images -->
                                    <v-layout class="mt-8">
                                      <!-- last picture -->
                                      <v-flex v-if="isActive">
                                        <v-layout wrap v-if="fbPhotos">
                                          <v-flex
                                            class="xs3 pa-2"
                                            v-for="(photo,
                                            index) in fbPhotos.data"
                                            :key="index"
                                          >
                                            <v-card
                                              @click="
                                                onHandleSelectImageFb(
                                                  photo.images[0].source,
                                                  i
                                                )
                                              "
                                            >
                                              <v-img
                                                style="cursor: pointer"
                                                aspect-ratio="1"
                                                width="100%"
                                                :src="photo.images[0].source"
                                              ></v-img>
                                            </v-card>
                                          </v-flex>
                                        </v-layout>

                                        <v-layout mt-4 justify-space-between>
                                          <v-spacer></v-spacer>
                                          <v-flex shrink mx-2>
                                            <v-btn
                                              dark
                                              :color="
                                                fbPhotos.paging.previous
                                                  ? '#FD5246'
                                                  : '#d48b869d'
                                              "
                                              @click="
                                                fbPhotos.paging.previous
                                                  ? onPreviousPagePhoto(
                                                      'last-photo',
                                                      fbPhotos.paging.previous
                                                    )
                                                  : ''
                                              "
                                            >
                                              <v-icon x-large color="#fff"
                                                >chevron_left</v-icon
                                              >
                                            </v-btn>
                                          </v-flex>
                                          <v-flex shrink mx-2>
                                            <v-btn
                                              dark
                                              :color="
                                                fbPhotos.paging.next
                                                  ? '#FD5246'
                                                  : '#d48b869d'
                                              "
                                              @click="
                                                fbPhotos.paging.next
                                                  ? onNextPagePhoto(
                                                      'last-photo',
                                                      fbPhotos.paging.next
                                                    )
                                                  : ''
                                              "
                                            >
                                              <v-icon x-large color="#fff">
                                                chevron_right
                                              </v-icon>
                                            </v-btn>
                                          </v-flex>
                                          <v-spacer></v-spacer>
                                        </v-layout>
                                      </v-flex>

                                      <!-- Album -->
                                      <v-flex v-else>
                                        <!-- album -->
                                        <v-layout wrap v-if="fbAlbum">
                                          <v-flex
                                            class="xs2 pa-2"
                                            v-for="album in fbAlbum"
                                            :key="album.id"
                                          >
                                            <div
                                              v-if="album.photos"
                                              class="card-album"
                                            >
                                              <v-img
                                                @click="
                                                  onHandleAlbum(album.photos)
                                                "
                                                aspect-ratio="1"
                                                width="100%"
                                                style="cursor: pointer"
                                                :src="album.picture.data.url"
                                              ></v-img>
                                              <div
                                                class="pa-2 title-album"
                                                style="font-size: 12px"
                                              >
                                                {{ album.name }}
                                              </div>
                                            </div>
                                          </v-flex>
                                        </v-layout>

                                        <v-divider class="my-4"></v-divider>

                                        <!-- photo -->
                                        <v-layout wrap v-if="album">
                                          <v-flex
                                            class="xs3 pa-4"
                                            v-for="(image, x) in album.data"
                                            :key="x"
                                          >
                                            <v-card
                                              @click="
                                                onHandleSelectImageFb(
                                                  image.images[0].source,
                                                  i
                                                )
                                              "
                                            >
                                              <v-img
                                                class="hover-image-fb"
                                                aspect-ratio="1"
                                                width="100%"
                                                style="cursor: pointer"
                                                :src="image.images[0].source"
                                              ></v-img>
                                            </v-card>
                                          </v-flex>
                                        </v-layout>

                                        <v-layout
                                          mt-4
                                          justify-space-between
                                          v-if="album"
                                        >
                                          <v-spacer></v-spacer>
                                          <v-flex shrink mx-2>
                                            <v-btn
                                              dark
                                              :color="
                                                album.paging.previous
                                                  ? '#FD5246'
                                                  : '#d48b869d'
                                              "
                                              @click="
                                                album.paging.previous
                                                  ? onPreviousPagePhoto(
                                                      'album',
                                                      album.paging.previous
                                                    )
                                                  : ''
                                              "
                                            >
                                              <v-icon x-large color="#fff">
                                                chevron_left
                                              </v-icon>
                                            </v-btn>
                                          </v-flex>
                                          <v-flex shrink mx-2>
                                            <v-btn
                                              dark
                                              :color="
                                                album.paging.next
                                                  ? '#FD5246'
                                                  : '#d48b869d'
                                              "
                                              @click="
                                                album.paging.next
                                                  ? onNextPagePhoto(
                                                      'album',
                                                      album.paging.next
                                                    )
                                                  : ''
                                              "
                                            >
                                              <v-icon x-large color="#fff"
                                                >chevron_right</v-icon
                                              >
                                            </v-btn>
                                          </v-flex>
                                          <v-spacer></v-spacer>
                                        </v-layout>
                                      </v-flex>
                                    </v-layout>
                                  </div>
                                </v-card>
                              </div>
                            </v-card-text>
                          </div>
                        </v-dialog>
                      </div>
                    </v-flex>

                    <v-flex xs12>
                      <span style="color: #FD5246; font-size: 12px">
                        รูปภาพต้องมีขนาดไม่เกิน 500k
                      </span>
                    </v-flex>
                  </v-layout>
                  <div class="text-center">
                    <v-btn
                      :disabled="isAdd"
                      outlined
                      :block="$vuetify.breakpoint.smAndDown"
                      @click="addAnImage"
                      color="#72C3B6"
                    >
                      <v-icon class="mr-2">add</v-icon>
                      {{ $t("add-port-img") }}
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex xs3> </v-flex>
              </v-layout>
              <v-divider class="my-7"></v-divider>

              <v-layout
                justify-space-around
                mb-5
                :column="$vuetify.breakpoint.smAndDown"
              >
                <v-btn
                  @click="$router.go(-1)"
                  depressed
                  class="mb-3 mb-md-0"
                  :block="$vuetify.breakpoint.smAndDown"
                  large
                  dark
                  width="170px"
                  color="#C4C4C4"
                  >{{ $t("cancel") }}</v-btn
                >
                <v-spacer />
                <v-btn
                  depressed
                  class="mb-3 mb-md-0 text-capitalize mr-4"
                  :block="$vuetify.breakpoint.smAndDown"
                  large
                  dark
                  outlined
                  width="170px"
                  color="#FD5246"
                  @click="onSubmitForm(1)"
                >
                  <span>Save and Preview</span>
                </v-btn>
                <v-btn
                  depressed
                  class="mb-3 mb-md-0"
                  :block="$vuetify.breakpoint.smAndDown"
                  large
                  dark
                  width="170px"
                  color="#FD5246"
                  @click="onSubmitForm(2)"
                  >{{ $t("save") }}</v-btn
                >
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <loading
      color="#FD5246"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>

    <Footer></Footer>
  </v-content>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import { mapActions, mapState, mapMutations } from "vuex";
import Service from "../services";
import { domain, imgPath } from "../services/Constants";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Editor from "@tinymce/tinymce-vue";
import axios from "axios";
import UploadService from "../services/API/image-upload";

export default {
  components: {
    Header,
    Footer,
    Loading,
    // editor: Editor
    Editor,
  },
  data: () => ({
    portfolio_id: "",
    files: null,
    // modal upload image
    isAdd: false,
    dialog: false,
    notifications: false,
    sound: true,
    widgets: false,
    btnUploadActive: true,
    btnFbActive: false,

    value: 0,
    query: false,
    interval: 0,
    show: false,
    showFb: false,

    progress: 0,
    progressFb: 0,

    isActive: true,
    fbAlbum: null,
    album: null,
    fbPhotos: null,
    nextPageLastPhoto: null,
    previousPageLastPhoto: null,

    http: domain,
    httpImgPath: imgPath,
    coverReload: true,
    coverShareReload: true,
    imgReload: true,
    btnSubmitIsLoading: false,
    categoryList: [],
    subcategoryList: [],
    subcategoryListAll: [],
    newTag: "",
    tagModal: false,
    btnTagLoading: false,
    portfolioTag: [],
    portfolioTagAward: [],
    tagType: 0,
    isLoading: false,
    isLoadingFb: false,
    isLoadingImageCover: false,
    isLoadingImageShare: false,
    isLoadingImageMore: false,
    fullPage: true,
    allTags: [],
    allAwardTags: [],
    // text editor
    text: "",
    category_id: null,
    portfolioDetail: {
      profile_id: null,
      category_id: null,
      subcategory_id: null,
      project_title: null,
      project_brief: null,
      detail: null,
      cover_img_path: null,
      cover_img_share_path: null,
      is_approve: 0,
      portfolio_image: [],
    },

    editorSetting: {
      init: {
        height: 500,
        menubar: "edit view insert format tools table",
        mobile: {
          height: 600,
          toolbar_mode: "sliding",
          // theme: 'mobile',
        },
        plugins:
          "print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable  charmap  emoticons",
        toolbar:
          "undo redo | bold italic underline strikethrough | forecolor backcolor\
                                             alignleft aligncenter alignright alignjustify | \
                                             fontselect fontsizeselect formatselect |\
                                             outdent indent |  numlist bullist checklist |\
                                             casechange permanentpen formatpainter removeformat |\
                                             pagebreak | fullscreen  preview save print |\
                                             insertfile image media pageembed link anchor |\
                                             a11ycheck ltr rtl",
        // enable title field in the Image dialog
        image_title: true,
        // enable automatic uploads of images represented by blob or data URIs
        automatic_uploads: true,
        // add custom filepicker only to Image dialog
        file_picker_types: "image",
        convert_urls: false,
        file_picker_callback: function(cb, value, meta) {
          var input = document.createElement("input");
          input.setAttribute("type", "file");
          input.setAttribute("accept", "image/*");

          input.onchange = function() {
            var file = this.files[0];
            var reader = new FileReader();
            reader.onload = function() {
              var id = "blobid" + new Date().getTime();
              var blobCache = tinymce.activeEditor.editorUpload.blobCache;
              var base64 = reader.result.split(",")[1];
              var blobInfo = blobCache.create(id, file, base64);
              blobCache.add(blobInfo);

              var fd = new FormData();
              fd.append("file", file);
              fd.append("file_name", file.name);
              axios({
                url: `${domain}api/image-up`,
                method: "POST",
                data: fd,
              })
                .then((result) => {
                  let image = domain + "storage/uploads/images/" + result.data;
                  cb(image, { title: file.name });
                })
                .catch((err) => {
                  console.log(err);
                });
            };
            reader.readAsDataURL(file);
          };

          input.click();
        },
      },
    },
  }),
  async created() {
    console.log(this.user.mem_info.domain_name);
    if (!this.access_token) {
      this.$swal({
        icon: "warning",
        title: this.$t("unauthorized"),
        confirmButtonColor: "#FD5246",
        confirmButtonText: "ตกลง",
      });
      // alert(this.$t('unauthorized'));
      this.$router.push("/login");
    } else {
      this.isLoading = true;
      await Promise.all([
        this.onGetCategory(),
        this.onGetSubCategory(),
        this.onGetAllTags(),
      ]).then(async () => {
        // for update
        if (this.$route.params.id) {
          await Promise.all([
            this.onGetPortfolio(parseInt(this.$route.params.id)),
            this.onGetTagPort(),
          ]);
        }
        this.isLoading = false;
      });
    }
  },

  watch: {
    dialog(val) {
      if (!val) {
        this.btnFbActive = false;
        this.btnUploadActive = true;
      }
    },
    onChangeCategory: function() {
      this.filterSubCate();
    },
    $route(to, from) {
      if (to.fullPath === "/create-portfolio") {
        this.portfolioDetail.profile_id = "";
        this.portfolioDetail.category_id = "";
        this.portfolioDetail.subcategory_id = "";
        this.portfolioDetail.project_title = "";
        this.portfolioDetail.project_brief = "";
        this.portfolioDetail.detail = "";
        this.portfolioDetail.cover_img_path = "";
        this.portfolioDetail.cover_img_share_path = "";
        this.portfolioDetail.is_approve = 0;
        this.portfolioDetail.portfolio_image = [];
        this.category_id = "";
        this.subcategoryList = [];
        this.portfolioTag = [];
        this.portfolioTagAward = [];
        this.onGetCategory();
        this.onGetSubCategory();
        this.onGetAllTags();
      } else {
        this.onGetPortfolio(parseInt(this.$route.params.id));
        this.onGetTagPort();
      }
    },
  },
  computed: {
    onChangeCategory: function() {
      return this.portfolioDetail.category_id;
    },
    ...mapState({
      personalInfo: (state) => state.profile.personalInfo,
      user: (state) => {
        return state.auth.users;
      },
      access_token: (state) => {
        return state.auth.access_token;
      },
      access_token_fb: (state) => {
        return state.auth.access_token_fb;
      },
    }),
  },
  async mounted() {
    await this.loadFacebookSDK(document, "script", "facebook-jssdk");
    await this.initFacebook();
  },
  methods: {
    ...mapActions("portfolio", ["onCreatePortfolio", "onEditPortfolio"]), // onUploadPortfolioImage
    ...mapActions("tag", ["onAddNewTag", "onTaggingPortfolio"]),
    checkCate(val) {
      return parseInt(val);
    },
    onGetPortfolio(id) {
      return Service.portfolio.getPortfolio(id).then((res) => {
        this.portfolioDetail = res.data;
        this.category_id = res.data.category_id.toString();
        console.log("category_id", this.category_id);
      });
    },
    onGetCategory() {
      return this.$store
        .dispatch("portfolio/onGetCategoryList")
        .then((res) => {
          this.categoryList = res.data;
          console.log("onGetCategory", this.categoryList);
        })
        .catch((e) => {
          console.log("Error on Get Category", e);
        });
    },
    onGetSubCategory() {
      return this.$store
        .dispatch("portfolio/onGetSubCategory")
        .then((res) => {
          if (res.status === 200) {
            this.subcategoryList = res.data;
            this.subcategoryListAll = res.data;
          }
        })
        .catch((e) => {
          console.log("Error on Get SubCategory", e);
          this.isLoading = false;
        });
    },
    onGetAllTags() {
      return Service.tag
        .getAllTags()
        .then((res) => {
          if (res.status === 200) {
            res.data.forEach((tag) => {
              if (tag.type == 0) {
                this.allTags.push(tag);
              } else if (tag.type == 1) {
                this.allAwardTags.push(tag);
              }
            });
          }
        })
        .catch((e) => {
          console.log("Error on Get All Tags", e);
          this.isLoading = false;
        });
    },
    async onSubmitForm(type) {
      this.isLoading = true;
      this.portfolioDetail["type"] = type;
      if (
        this.portfolioDetail.category_id == null ||
        this.portfolioDetail.category_id == ""
      ) {
        this.$swal({
          icon: "warning",
          title: this.$t("please-select-cate"),
          confirmButtonColor: "#FD5246",
          confirmButtonText: "ตกลง",
        });
        this.isLoading = false;
        return;
      }

      if (this.formIsValid()) {
        let profile_id = { profile_id: this.personalInfo.profile_id };
        if (this.$route.params.id) {
          // update
          // this.isLoading = true;
          this.portfolioDetail.category_id = this.category_id;
          Service.portfolio
            .editPortfolio(this.portfolioDetail, profile_id)
            .then(async () => {
              let param = {
                portfolio_id: this.$route.params.id,
                tags: this.portfolioTag,
                awardTags: this.portfolioTagAward,
                type: type,
              };
              await this.onTaggingPortfolio(param)
                .then(() => {
                  // alert(this.$t('edit-port-success'));
                  // this.onGetPortfolio(parseInt(this.$route.params.id));
                  this.onGetTagPort();
                  this.isLoading = false;
                  this.$swal({
                    icon: "success",
                    title: this.$t("edit-port-success"),
                    confirmButtonColor: "#FD5246",
                    confirmButtonText: "ตกลง",
                  }).then((res) => {
                    this.$router.push("/profile-about");
                    // this.$router.push({ name: 'UpdateProfile', params: { id: profile_id } });
                  });
                })
                .catch((e) => {
                  this.isLoading = false;
                  console.log("error on Tagging Portfolio", e);
                });

              //
            })
            .catch((e) => {
              this.isLoading = false;
              this.isLoading = false;
              console.log("error edit Portfolio", e);
            });
        } else {
          // create
          Service.portfolio
            .createPortfolio(this.portfolioDetail, profile_id)
            .then(async (res) => {
              this.portfolio_id = res.data.portfolio_id;
              let param = {
                portfolio_id: res.data.portfolio_id,
                tags: this.portfolioTag,
                awardTags: this.portfolioTagAward,
                type: type,
              };
              await this.onTaggingPortfolio(param);
              // this.onGetPortfolio(parseInt(res.data.portfolio_id));
              this.isLoading = false;
              this.$swal({
                icon: "success",
                title: this.$t("create-port-success"),
                confirmButtonColor: "#FD5246",
                confirmButtonText: "ตกลง",
              }).then((res) => {
                if (type == 1) {
                  // let routeData = this.$router.resolve({
                  //   path: `/preview/${this.user.mem_info.domain_name}/${this.portfolio_id}`,
                  // });
                  // window.open(routeData.href, "_blank");
                  this.$router.push(
                    `/preview/${this.user.mem_info.domain_name}/${this.portfolio_id}`
                  );
                } else {
                  this.$router.push("/profile-about");
                }
              });
            })

            .catch((err) => {
              this.isLoading = false;
              this.$swal({
                icon: "error",
                title: this.$t("create-port-error"),
                confirmButtonColor: "#FD5246",
                confirmButtonText: "ตกลง",
              });
            });
        }
      } else {
        this.$swal({
          icon: "error",
          title: this.$t("validate-field"),
          confirmButtonColor: "#FD5246",
          confirmButtonText: "ตกลง",
        });
        this.btnSubmitIsLoading = false;
      }
    },
    formIsValid() {
      if (
        this.dataIsCorrect(this.category_id) &&
        this.dataIsCorrect(this.portfolioDetail.project_title) &&
        this.dataIsCorrect(this.portfolioDetail.project_brief)
        // this.dataIsCorrect(this.portfolioDetail.cover_img_path) &&
        // this.dataIsCorrect(this.portfolioDetail.detail)
      ) {
        return true;
      } else {
        return false;
      }
    },
    dataIsCorrect(data) {
      return data !== null && data !== "";
    },
    clickImageInput(id) {
      this.$refs[`imageport_${id}`][0].click();
    },
    onCoverChanged(e) {
      this.isLoadingImageCover = true;
      if (e.target.files[0]) {
        this.coverReload = false;
        let param = { image: e.target.files[0], type: "portfolio-cover" };
        // await this.onUploadPortfolioImage(param);
        this.$store
          .dispatch("portfolio/onUploadPortfolioImage", param)
          .then((res) => {
            this.portfolioDetail.cover_img_path = res.data;
            this.coverReload = true;
            this.isLoadingImageCover = false;
          })
          .catch((e) => {
            this.coverReload = true;
            this.isLoadingImageCover = false;
            this.$swal({
              icon: "warning",
              title: e.response.data.message,
              confirmButtonColor: "#FD5246",
              confirmButtonText: "ตกลง",
            });
          });
      } else {
        this.isLoadingImageCover = false;
      }
    },
    clearCoverImage(val) {
      this.portfolioDetail.cover_img_path = val;
      document.getElementById("portfolio_cover").value = "";
    },
    onCoverShareChanged(e) {
      this.isLoadingImageShare = true;
      if (e.target.files[0]) {
        this.coverShareReload = false;
        let param = { image: e.target.files[0], type: "portfolio-cover-share" };
        this.$store
          .dispatch("portfolio/onUploadPortfolioImage", param)
          .then((res) => {
            this.portfolioDetail.cover_img_share_path = res.data;
            this.coverShareReload = true;
            this.isLoadingImageShare = false;
          })
          .catch((e) => {
            this.coverShareReload = true;
            this.isLoadingImageShare = false;
            this.$swal({
              icon: "warning",
              title: this.$t("please-select-cate"),
              confirmButtonColor: "#FD5246",
              confirmButtonText: "ตกลง",
            });
          });
      } else {
        this.isLoadingImageCover = false;
      }
    },
    clearCoverImageShare(val) {
      document.getElementById("portfolio_cover_share").value = "";
      this.portfolioDetail.cover_img_share_path = val;
    },
    addAnImage() {
      this.portfolioDetail.portfolio_image.push({
        img_path: null,
        detail: "",
      });
      this.isAdd = true;
    },
    removeAnImage(id) {
      this.portfolioDetail.portfolio_image = this.portfolioDetail.portfolio_image.filter(
        (item, i) => i !== id
      );
      this.isAdd = false;
    },
    bytesToSize(bytes, decimals = 2) {
      if (bytes === 0) return "0 Bytes";

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },
    async onMoreImgChanged(e, id) {
      if (e.target.files[0]) {
        // 1k = 1,000 byte
        // 500k = 500,000 byte
        var file = e.target.files[0];
        this.files = "ขนาดไฟล์รูปภาพของคุณคือ : " + this.bytesToSize(file.size);
        // check file size
        if (file.size > 500000) {
          this.$swal({
            icon: "warning",
            title: "ขนาดไฟล์ต้องมีขนาดไม่เกิน 500k",
            text: this.files,
            confirmButtonColor: "#FD5246",
            confirmButtonText: "ตกลง",
          });
          document.getElementById(`imageport_${id}`).value = "";
        } else {
          this.show = true;
          this.imgReload = false;
          let param = {
            id: id,
            image: e.target.files[0],
            type: "portfolio-images",
          };

          UploadService.upload(param, (event) => {
            this.progress = Math.round((100 * event.loaded) / event.total);
          })
            .then((res) => {
              this.$store.commit("portfolio/setMoreImages", {
                id: id,
                name: res.data,
              }); // Commit path img to store

              this.portfolioDetail.portfolio_image[id].img_path = res.data;
              this.imgReload = true;
              this.isAdd = false;
              setTimeout(() => {
                this.show = false;
                this.progress = 0;
                this.dialog = false;
              }, 1000);
            })
            .catch(() => {
              this.progress = 0;
            });
        }
      } else {
        this.isLoading = false;
      }
    },
    changeCategory() {
      this.portfolioDetail.category_id = this.category_id;
      Service.categoty
        .getSubCategoryById(this.category_id)
        .then((res) => {
          this.portfolioDetail.subcategory_id = "";
          this.subcategoryList = res.data;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    setTagType(type) {
      this.tagType = type;
      this.tagModal = !this.tagModal;
    },
    async addTag() {
      if (this.dataIsCorrect(this.newTag)) {
        // type 0 = tag, 1 = tag award
        let param = { name: this.newTag, type: this.tagType };
        this.btnTagLoading = true;
        this.isLoading = true;
        this.onAddNewTag(param).then(async (res) => {
          // when tag was added then select that tag
          if (res) {
            await this.onGetAllTags();
            if (this.tagType == 0) {
              this.allTags.find((tag) => {
                if (tag.name == this.newTag) {
                  this.portfolioTag.push(tag.id);
                }
              });
            } else {
              this.allAwardTags.find((tag) => {
                if (tag.name == this.newTag) {
                  this.portfolioTagAward.push(tag.id);
                }
              });
            }
          }
          this.newTag = "";
          this.tagModal = false;
          this.btnTagLoading = false;
          this.isLoading = false;
        });
      }
    },
    onGetTagPort() {
      return Service.tag
        .getTagPortfolio(parseInt(this.$route.params.id))
        .then((res) => {
          if (res.status === 200) {
            this.portfolioTag = [];
            this.portfolioTagAward = [];
            res.data.tags.filter((item) => {
              if (item.tag.type == 0) {
                this.portfolioTag.push(parseInt(item.tag_id));
              } else {
                this.portfolioTagAward.push(parseInt(item.tag_id));
              }
            });
            this.isLoading = false;
          }
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    filterSubCate() {
      if (this.portfolioDetail.subcategory_id) {
        this.portfolioDetail.subcategory_id = parseInt(
          this.portfolioDetail.subcategory_id
        );
        this.subcategoryList = this.subcategoryListAll.filter((item) => {
          if (item.category_id == this.portfolioDetail.category_id) {
            return item;
          }
        });
      } else {
        this.subcategoryList = [];
      }
    },
    onHandleBtnUploadImage(btn) {
      if (btn === "upload") {
        this.btnFbActive = false;
        this.btnUploadActive = true;
        this.isActive = true;
        this.showFb = false;
        this.fbAlbum = null;
        this.album = null;
        this.fbPhotos = null;
      } else {
        this.isActive = true;
        this.btnFbActive = true;
        this.btnUploadActive = false;
        this.showFb = false;

        this.getLoginStatus();
      }
    },

    // SET init Facebook
    async initFacebook() {
      return (window.fbAsyncInit = function() {
        window.FB.init({
          appId: "806762203217212", //You will need to change this
          cookie: true, // This is important, it's not enabled by default
          version: "v7.0",
        });
      });
    },

    // Connect FB SDK
    async loadFacebookSDK(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
      return;
    },

    // Check stasus login facebook
    getLoginStatus() {
      let _this = this;
      window.FB.getLoginStatus(function(response) {
        if (response.status === "connected") {
          _this.getImgFb(response.authResponse.accessToken);
        } else {
          FB.login(function(res) {
            _this.$store.commit(
              "auth/setAccessTokenFB",
              res.autResponse.accessToken
            );
            if (res.status === "connected") {
              _this.getImgFb();
            }
          });
        }
      });
    },

    // Call API get image from facebook
    getImgFb(token) {
      this.isLoadingFb = true;
      const url = `https://graph.facebook.com/me?fields=id,albums{description,name,picture{url},photos.limit(12){images}}&access_token=${token}`;
      axios({
        url: url,
        method: "get",
      })
        .then((res) => {
          const response = res.data;
          //! check albums
          if (response && response.albums) {
            this.fbAlbum = response.albums.data;
            this.nextPageLastPhoto = response.albums.data[0].photos.paging.next;
            this.fbPhotos =
              response.albums.data.length > 0
                ? response.albums.data[0].photos
                : null;
            this.isLoadingFb = false;
          } else {
            this.$swal({
              icon: "warning",
              title: "Get Photos Facebook Failed!",
              text: "เกิดข้อผิดพลาดในการดึงรูปภาพจาก Facebook",
              confirmButtonColor: "#FD5246",
              confirmButtonText: "ตกลง",
            });
            // window.location.reload();
            this.showFb = false;
            this.fbAlbum = null;
            this.album = null;
            this.fbPhotos = null;
            this.dialog = false;
            this.progressFb = 0;
            this.getLoginStatus();
          }
        })
        .catch((err) => {
          //! Token Facebook Expire
          let _this = this;
          if (err.response.data.error.code === 190) {
            FB.login(function(res) {
              _this.$store.commit(
                "auth/setAccessTokenFB",
                res.authResponse.accessToken
              );
              if (res.status === "connected") {
                _this.getImgFb(res.authResponse.accessToken);
              }
            });
          }
        });
    },
    onNextPagePhoto(type, link) {
      this.isLoadingFb = true;
      axios({
        url: link,
        method: "get",
      })
        .then((res) => {
          this.isLoadingFb = false;
          this.isLoadingFb = false;
          if (type === "last-photo") {
            this.fbPhotos = res.data;
          } else if (type === "album") {
            this.album = res.data;
          } else {
            console.log("not match!");
          }
        })
        .catch((err) => {
          //! Token Facebook Expire
          let _this = this;
          if (err.response.data.error.code === 190) {
            FB.login(function(res) {
              _this.$store.commit(
                "auth/setAccessTokenFB",
                res.authResponse.accessToken
              );
              if (res.status === "connected") {
                _this.getImgFb(res.authResponse.accessToken);
              }
            });
          }
        });
    },
    onPreviousPagePhoto(type, link) {
      this.isLoadingFb = true;
      axios({
        url: link,
        method: "get",
      })
        .then((res) => {
          this.isLoadingFb = false;
          if (type === "last-photo") {
            this.fbPhotos = res.data;
          } else if (type === "album") {
            this.album = res.data;
          } else {
            console.log("not match!");
          }
        })
        .catch((err) => {
          //! Token Facebook Expire
          let _this = this;
          if (err.response.data.error.code === 190) {
            FB.login(function(res) {
              _this.$store.commit(
                "auth/setAccessTokenFB",
                res.authResponse.accessToken
              );
              if (res.status === "connected") {
                _this.getImgFb(res.authResponse.accessToken);
              }
            });
          }
        });
    },
    onHandleAlbum(album) {
      this.album = album;
    },
    onHandleSelectImageFb(img, id) {
      this.showFb = true;

      UploadService.uploadImageFb(img, (event) => {
        this.progressFb = Math.round((100 * event.loaded) / event.total);
        if (this.progressFb === 100) {
          this.isLoadingFb = true;
        }
      })
        .then((res) => {
          this.portfolioDetail.portfolio_image[id].img_path = res.data;
          this.imgReload = true;
          setTimeout(() => {
            this.progressFb = 0;
            this.showFb = false;
            this.fbAlbum = null;
            this.album = null;
            this.fbPhotos = null;
            this.dialog = false;
            this.isLoadingFb = false;
            this.isAdd = false;
          }, 1000);
        })
        .catch((err) => {
          this.$swal({
            icon: "warning",
            title: "Set image Failed!",
            text: err,
            confirmButtonColor: "#FD5246",
            confirmButtonText: "ตกลง",
          });
          this.showFb = false;
          this.fbAlbum = null;
          this.album = null;
          this.fbPhotos = null;
          this.dialog = false;
          this.progressFb = 0;
        });
    },
  },
};
</script>

<style lang="scss">
@import "~vue-wysiwyg/dist/vueWysiwyg.css";
.btn-fb {
  color: #c5c5c5;
}
.active-btn-fb {
  color: #189bff;
}
.btn-upload {
  color: #c5c5c5;
}
.active-btn-upload {
  color: #ef3e2d;
}
.modal-upload {
  height: 300px;
  position: relative;
  background-color: #f8f8f8;
  /* display: flex;
  justify-content: center;
  align-items: center; */
}
.upload-fb-btn {
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
}
.upload-fb-btn:hover {
  color: #fd5246;
  border-bottom: 2px solid #fd5246;
  .title-upload-fb {
    color: #fd5246;
  }
}
.title-upload-fb {
  color: #000;
}
.active-select-btn-fb {
  .title-upload-fb {
    color: #fd5246;
  }
  color: #fd5246;
  border-bottom: 2px solid #fd5246;
}
.title-album {
  white-space: nowrap;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.card-album {
  box-shadow: 0px 0px 10px -4px #434343;
  background-color: #fff;
}
.card-album:hover {
  box-shadow: 0px 4px 15px -6px rgb(67, 67, 67);
}
.hover-image-fb:hover {
  box-shadow: 0px 5px 15px 0px rgb(124, 124, 124);
}
</style>
